import React from 'react';
import PropTypes from 'prop-types';
import { ConfirmModal } from '@metarouter-private/mr-mui';
import ConfirmSendEventMessage from './ConfirmSendEventMessage';
import { PlayCircleIcon } from '@metarouter-private/mr-mui';

export default function ConfirmSendEventModal({ integrationName, clusterName, ...confirmModalProps }) {
  return (
    <ConfirmModal
      {...confirmModalProps}
      message={<ConfirmSendEventMessage integrationName={integrationName} clusterName={clusterName} />}
      title="Confirm Send Event to Live Integration"
      TitleIcon={PlayCircleIcon}
      confirmLabel="Send Live Event"
      ConfirmProps={{ variant: 'contained', color: 'primary' }}
    />
  );
}

ConfirmSendEventModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  integrationName: PropTypes.string.isRequired,
  clusterName: PropTypes.string.isRequired,
};
